export default __webpack_public_path__ + "static/media/commerce.d592dd99.jpg";